import { Fragment } from "react";
import { Menu } from "@headlessui/react";
import { logout } from "../../../redux/actions/auth";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  AccountIcon,
  DarkModeIcon,
  LogoutIcon,
  ManagebeneficiariesIcon,
  ManualIcon,
  ReportIcon,
  SettingIcon,
  StatementIcon,
  UpArrowIcon,
} from "../../Icons";
import CustomTransition from "../../CustomTransition";
import { WalletIcon } from "../../../crypto/icons";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function Profile({
  email,
  userName,
  profilePicture,
  setBalanceCertificate,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.user);
  const company = useSelector((state) => state.ownCompany.company);

  const handelLogout = async () => {
    await dispatch(logout());
  };

  const donwloadManual = () => {
    if (company && company.client_manual) {
      const link = document.createElement("a");
      link.href = company.client_manual;
      link.setAttribute("download", "manual.pdf");
      link.target = "_blank";
      document.body.appendChild(link);
      link.click();
    }
  };

  const clientAccounts = useSelector((state) => state.client.clientInfo);
  const accounts = clientAccounts?.accounts ?? [];

  return (
    <Menu as="div" className="relative inline-block  text-left">
      <div>
        <Menu.Button>
          {({ open }) => (
            <>
              <div
                className={classNames(
                  open ? "header-active" : "header-hover",
                  "flex items-center rounded-full p-2  ",
                )}
              >
                {profilePicture ? (
                  <img
                    className="h-8 w-8 rounded-full mx-1 mr-3 max-[576px]:mr-0"
                    src={
                      profilePicture ? profilePicture : "assets/gifs/loader.gif"
                    }
                    alt="profile_picture"
                  />
                ) : (
                  <AccountIcon className="h-8 w-8 rounded-full mx-1 mr-3 max-[576px]:mr-0" />
                )}
                <label
                  className="profile-text max-[445px]:hidden max-[576px]:pl-2 text-sm font-medium leading-tight tracking-tight max-w-[185px] truncate"
                  title={userName}
                >
                  {userName && userName}
                </label>
                <div className="mx-3">
                  <UpArrowIcon
                    src="/assets/up_arrow.svg"
                    className={`h-6 w-6 ${
                      open
                        ? "rotate--180 transition-transform duration-500"
                        : "rotate-180 transition-transform duration-500"
                    }`}
                    alt="up arrow"
                  />
                </div>
              </div>
            </>
          )}
        </Menu.Button>
      </div>

      <CustomTransition
        as={Fragment}
        enter="transition ease-out duration-500"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-500"
      >
        <Menu.Items className="profile-menu absolute right-0 z-10 mt-2 min-w-max max-[375px]:max-w-[360px] origin-top-right rounded-3xl shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none p-6">
          <div className="flex justify-between">
            <div className="flex flex-col space-y-1">
              <label className="profile-username-lable text-sm font-medium leading-tight tracking-tight max-w-[185px]">
                {userName && userName}
              </label>
              <label className="profile-email-lable text-sm font-normal leading-tight tracking-tight">
                {email && email}
              </label>
            </div>
            <div className="flex items-center">
              {profilePicture ? (
                <img
                  className="w-12 h-12 rounded-full border-2 border-divider"
                  src={
                    profilePicture ? profilePicture : "assets/gifs/loader.gif"
                  }
                  alt="profile_picture"
                />
              ) : (
                <AccountIcon className="w-12 h-12 rounded-full border-2 border-divider" />
              )}
            </div>
          </div>

          <hr className="h-px my-2 bg-divider border-0 " />
          <MenuItem
            title="Switch to Dark Mode"
            className={"max-[575px]:block hidden"}
            icon={<DarkModeIcon />}
          />
          {user && !user.is_basic_client && (
            <>
              <MenuItem
                title="Manage Beneficiaries"
                icon={<ManagebeneficiariesIcon />}
                onClick={() => navigate("/manage_beneficiery")}
              />
              <MenuItem
                title="Manage Crypto Beneficiaries"
                icon={<WalletIcon className="text-primary-600 w-[18px] h-[18px]" />}
                onClick={() => navigate("/v2/manage_crypto_beneficiaries")}
              />
              {accounts && accounts.length > 0 && (
                <MenuItem
                  title="Balance Certificate"
                  icon={<ReportIcon />}
                  onClick={() => setBalanceCertificate(true)}
                />
              )}
              <MenuItem
                title="Services Requests List"
                icon={<StatementIcon />}
                onClick={() => navigate("/services-requests")}
              />
            </>
          )}
          <MenuItem
            title="Settings"
            icon={<SettingIcon />}
            onClick={() => navigate("/settings")}
          />
          <MenuItem
            title="Download Manual"
            icon={<ManualIcon />}
            onClick={donwloadManual}
          />
          <MenuItem
            title="Logout"
            icon={<LogoutIcon />}
            onClick={handelLogout}
          />
        </Menu.Items>
      </CustomTransition>
    </Menu>
  );
}

const MenuItem = ({ title, icon, onClick, className }) => {
  return (
    <div onClick={onClick} className={className}>
      <Menu.Item>
        <div className="profile-menu-item self-stretch p-2 rounded-full justify-start items-center gap-x-2.5 inline-flex">
          <div className="relative rounded-full">
            <div className="profile-menu-icon w-12 h-12 rounded-full flex items-center justify-center">
              {icon}
            </div>
          </div>
          <label className="profile-menu-title w-[244px] text-base font-medium leading-tight tracking-tight">
            {title}
          </label>
        </div>
      </Menu.Item>
    </div>
  );
};
